//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.LengthLimitPointBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.FaceSetData.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"IsOk",1,0],[1,"LengthLimitPoint",0,"GeometricUtilities.LengthLimitPointBuilder",0],[0,"LimitTopolSwitchFinFlag",1,0],[0,"PlaneHelpPoint",1,"Point",0],[1,"SelectEdge",0,"ScCollector",0],[1,"SelectFace",0,"GeometricUtilities.FaceSetData",0],[0,"SelectPlane",1,"Plane",0],[0,"TrimObject",1,0],[0,"UseFaceCapBlend",1,0],[0,"UsePlaneCapBlend",1,0]],[[["mOnPathExp","mOnPath","mIsFlipped","mThruPoint"],"CreateLengthLimitPointBuilder",{R_:{lengthLimitPointBuilder:"GeometricUtilities.LengthLimitPointBuilder"}},4,0]],[]];
SPLM.GeometricUtilities.PointFacePlaneSelectionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.PointFacePlaneSelectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.PointFacePlaneSelectionBuilder.TrimObjectType = Object.freeze({
    "Point" : "Point", "Plane" : "Plane", "Face" : "Face", "Edge" : "Edge"});

export default SPLM;